import $ from 'jquery';

$(function() {
    //counter
    let $slider = $('.slider-news');

    if ($slider.length) {
        let currentSlide;
        let slidesCount;
        let sliderCounter = $('#countNews')
        let sliderCounterWrapper = $('#counterWrapper')

        let updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            if (slick.slideCount > 4) {
                sliderCounterWrapper.parent().addClass('on');
                $(sliderCounterWrapper).html('<span class="counter">' + currentSlide + '</span><span class="total">/' + slidesCount + '</span>')
            }
        };

        $slider.on('init', function(event, slick) {
            $slider.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $slider.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $slider.slick({
            // autoplay: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            prevArrow: $('.previous'),
            nextArrow: $('.next'),
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }

});
